import { onMounted, onBeforeUnmount, ref, getCurrentInstance, type Ref } from "vue"

function useComponentWidth(): Ref<number> {
  const componentWidth = ref(0)
  let resizeObserver: ResizeObserver
  let element: HTMLElement | null = null

  function handleResize() {
    if (element) {
      componentWidth.value = element.clientWidth
    }
  }

  onMounted(() => {
    const instance = getCurrentInstance()
    if (instance && instance.proxy) {
      element = instance.proxy.$el as HTMLElement
    }

    if (!element) {
      return
    }

    handleResize()
    resizeObserver = new ResizeObserver(handleResize)
    resizeObserver.observe(element)
  })

  onBeforeUnmount(() => {
    if (element) {
      resizeObserver.unobserve(element)
    }
  })

  return componentWidth
}

export default useComponentWidth
